<h2 mat-dialog-title class="dialog-title">Editar Regla de Costo</h2>

<mat-dialog-content class="dialog-content">
  <p class="dialog-subtitle">Seleccioná la categoría para este turno:</p>

  <div *ngIf="data.rules.length === 0" class="no-rules-message">
    No se encontraron reglas activas.
  </div>

  <mat-radio-group *ngIf="data.rules.length > 0" [(ngModel)]="selectedRuleId" class="rules-radio-group">
    <mat-radio-button *ngFor="let rule of data.rules" [value]="rule.id" class="rule-option">
      <div class="rule-content">
        <span class="rule-name">{{ rule.categoryName }}</span>
        <span class="rule-value">{{ formatValue(rule.value) }}</span>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button class="cancel-btn" (click)="cancel()">Cancelar</button>
  <button mat-flat-button class="confirm-btn" (click)="confirm()" [disabled]="selectedRuleId === null">
    Aceptar
  </button>
</mat-dialog-actions>
